var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagLevel,{tag:"component",staticClass:"a-heading",class:_vm.priorityClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }